import React, { useState, useEffect } from 'react';
import { getSpiritualFamilies, deleteSpiritualFamily, getEligibleFathers } from '../../services/api';
import { FiSearch, FiTrash2, FiEye, FiUsers } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import Toast from '../../components/Toast';
import FamilyDetail from './FamilyDetail';

const AllFamilies = () => {
  const navigate = useNavigate();
  const [families, setFamilies] = useState([]);
  const [fathers, setFathers] = useState([]);
  const [search, setSearch] = useState('');
  const [fatherFilter, setFatherFilter] = useState('');
  const [toast, setToast] = useState(null);
  const [viewFamily, setViewFamily] = useState(null);

  const showToast = (msg, type = 'success') => { setToast({ msg, type }); setTimeout(() => setToast(null), 3000); };

  const fetch = () => getSpiritualFamilies({ search, father_id: fatherFilter }).then(r => setFamilies(Array.isArray(r.data) ? r.data : [])).catch(() => {});

  useEffect(() => {
    fetch();
    getEligibleFathers().then(r => setFathers(Array.isArray(r.data) ? r.data : [])).catch(() => {});
  }, [search, fatherFilter]);

  const handleDelete = async (f) => {
    if (!window.confirm(`Delete family "${f.family_name}"?`)) return;
    await deleteSpiritualFamily(f.id);
    showToast('Family deleted', 'error');
    fetch();
  };

  return (
    <div className="page-content">
      <div className="page-header">
        <div><h1>All Families</h1><p>{families.length} families</p></div>
        <button className="btn btn-primary" onClick={() => navigate('/spiritual/add-family')}>+ Add Family</button>
      </div>

      <div className="filters-row">
        <div className="search-input-container" style={{ margin: 0, flex: 1, maxWidth: 300 }}>
          <FiSearch style={{ color: '#9ca3af' }} />
          <input placeholder="Search family or head name..." value={search} onChange={e => setSearch(e.target.value)} />
        </div>
        <select className="filter-select" value={fatherFilter} onChange={e => setFatherFilter(e.target.value)}>
          <option value="">All Fathers</option>
          {fathers.map(f => <option key={f.id} value={f.id}>{f.first_name} {f.last_name}</option>)}
        </select>
      </div>

      <div className="table-card">
        <table>
          <thead>
            <tr>
              <th>#</th><th>Family Name</th><th>Head</th><th>Wife</th>
              <th>Children</th><th>Spiritual Father</th><th>Last Follow-up</th><th>Next Follow-up</th><th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {families.length === 0 ? (
              <tr><td colSpan={9}><div className="empty-state"><div className="empty-icon"><FiUsers /></div><p>No families found</p></div></td></tr>
            ) : families.map((f, i) => (
              <tr key={f.id}>
                <td data-label="#">{i + 1}</td>
                <td data-label="Family Name"><strong>{f.family_name}</strong></td>
                <td data-label="Head">{f.head_name || '—'}</td>
                <td data-label="Wife">{f.wife_name || '—'}</td>
                <td data-label="Children">{f.children_count}</td>
                <td data-label="Spiritual Father">{f.father_name || '—'}</td>
                <td data-label="Last Follow-up">{f.last_followup || '—'}</td>
                <td data-label="Next Follow-up" style={{ color: f.next_followup && f.next_followup < new Date().toISOString().slice(0, 10) ? '#dc2626' : 'inherit', fontWeight: f.next_followup && f.next_followup < new Date().toISOString().slice(0, 10) ? 700 : 'normal' }}>
                  {f.next_followup || '—'}
                </td>
                <td data-label="Actions">
                  <div className="action-btns">
                    <button className="btn-icon" onClick={() => setViewFamily(f.id)} title="View"><FiEye /></button>
                    <button className="btn-icon danger" onClick={() => handleDelete(f)} title="Delete"><FiTrash2 /></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {viewFamily && <FamilyDetail familyId={viewFamily} onClose={() => { setViewFamily(null); fetch(); }} showToast={showToast} />}
      <Toast message={toast?.msg} type={toast?.type} onClose={() => setToast(null)} />
    </div>
  );
};

export default AllFamilies;
